import React from 'react';
import { NetworkStatus } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import InfiniteScrollTable from '../../../components/InfiniteScrollTable';
import { useLocationListQuery } from '../../../generated/graphql';
import useQueryParams from '../../../hooks/useQueryParams';
import { dummyLocations } from '../dummy';
import LocationListItem from './LocationListItem';

const LocationList = () => {
  const queryParams = useQueryParams();
  const history = useHistory();
  const filters = queryParams.get('filters');

  const { data, loading, error, fetchMore, networkStatus } = useLocationListQuery({
    // It is just too complicated to update cached queries after
    // mutations have succeeded
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      // infinite flag is a hack to make the cache's "FielPolicy" read function
      // return all items
      // @ts-ignore
      infinite: true,
    },
  });

  const { data: locations, paginatorInfo } = data?.locations || {};
  const { currentPage, hasMorePages } = paginatorInfo || {};
  const loadingMore = networkStatus === NetworkStatus.fetchMore;

  return (
    <InfiniteScrollTable
      interactive
      columns={[{ heading: 'Name' }, { heading: 'Adresse' }, { heading: 'Treffpunkt' }]}
      loading={loading}
      loadingMore={loadingMore}
      hasFilters={!!filters}
      empty={!locations?.length}
      hasMorePages={!!hasMorePages}
      hasError={!!error}
      onLoadMore={() =>
        fetchMore({
          variables: {
            page: (currentPage || 1) + 1,
          },
        })
      }
    >
      {(loading && !loadingMore ? dummyLocations : locations || []).map((item) => (
        <LocationListItem
          key={item.id}
          item={item}
          skeleton={loading && !loadingMore}
          onClick={() => !loading && history.push(`/locations/${item!.id}`)}
        />
      ))}
    </InfiniteScrollTable>
  );
};

export default LocationList;
